import React, {useState, useRef, Fragment} from 'react';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import {useTranslation} from "react-i18next";
import Button from '@mui/material/Button';
import {useGlobalStorage} from './mobx/GlobalStorage.js';
import ProgDialog from './ProgDialog.js';
import {COMM_OK} from './WsR2.js';

function UploadButton(props) {
	const [progDlgOpen, setProgDlgOpen] = useState(false);
	const [errmsg, setErrMsg] = useState('');
	const [prog, setProg] = useState(0);
	const [msg, setMsg] = useState('');
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');
	const fileInput = useRef();
	let start = 0, file_id = 0;

	function acceptMask() {
		if (!props.filemask)
			return 'image/png,image/jpeg';

		return props.filemask;
	}

	function ulBtnRxWs(status, msg) {
		let file = fileInput.current.files[0];

		if (status !== COMM_OK || msg.result !== 'OK') {
			console.error('descRxWs: error ', status);
			fileInput.current.value = null;

			if (status === COMM_OK) {
				setErrMsg(msg.data.desc);
			} else {
				setErrMsg('Status ' + status + '!');
			}

			setProg(-1);
			return -1;
		}

		if (msg.cmd === 'file') {
// 			console.log('ulBtnRxWs:', msg.cmd, msg.op);

			if (msg.op === 'ul_start') {
				file_id = msg.data.file.id;
				start = 0;

				loadChunk();
			} else if (msg.op === 'ul_block') {
				let prog;

				start += (128 * 1024);

				prog = Math.round((start * 100) / file.size);
				if (prog < 0) {
					prog = 0;
				} else if (prog > 100) {
					prog = 100;
				}

				setProg(prog);

				if (start >= file.size) {
					let msg = {
						sess_id: gStorage.conn.sess_id,
						cmd: 'file',
						op: 'ul_end',
						data: {
							file: {
								id: file_id
							}
						}
					};

					gStorage.conn.ws.send(msg, ulBtnRxWs);
				} else {
					loadChunk();
				}
			} else if (msg.op === 'ul_end') {
// 				console.log('ulBtnRxWs: done!');
				setProgDlgOpen(false);
				fileInput.current.value = null;
				props.refresh && props.refresh();
			} else {
				console.error('ulBtnRxWs: unknown operation:', msg.cmd, msg.op);
				fileInput.current.value = null;
			}
		} else {
			console.error('ulBtnRxWs: unknown cmd', msg.cmd, msg.op);
			fileInput.current.value = null;
		}
	}

	const loadChunk = () => {
		let reader = new FileReader();
		let file = fileInput.current.files[0];

// 		console.log('loadChunk', file);

		reader.onloadend = () => {
// 			console.log('onloadend', file.name);
			if (reader.error) {
				console.log('    error', file.name, reader.error, typeof(reader.error));

				setErrMsg(reader.error.message);
				setProg(-1);
				fileInput.current.value = null;
			}
		}

		reader.onload = function(e) {
			let msg = {
				sess_id: gStorage.conn.sess_id,
				cmd: 'file',
				op: 'ul_block',
				data: {
					file: {
						id: file_id, 
						content: Buffer.from(reader.result).toString('base64')
					}
				}
			};

			gStorage.conn.ws.send(msg, ulBtnRxWs);
		}

		reader.readAsArrayBuffer(file.slice(start, start + (128 * 1024)));
	}

	function handleImageChange(e) {
		let file = fileInput.current.files[0];

		setProg(-1);
		setMsg(file.name);
		setProgDlgOpen(true);

		if (file.size <= 0 || file.size > 5 * 1024 * 1024) {
			fileInput.current.value = null;	
			setErrMsg('Invalid size: ' + file.size + ' B!');
			return -1;
		}

		setProg(0);

		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'file',
			op: 'ul_start',
			data: {
				file: {
					name: file.name,
					size: file.size,
					caption: '',
					desc: '',
					copyright: '',
					public: 1,
				}, 
				target: props.target,
			}
		};

		gStorage.conn.ws.send(msg, ulBtnRxWs);
	}

	function handleClose() {
		setErrMsg('');
		setProgDlgOpen(false);
	}

	/*capture="environment"*/

	return (
		<Fragment>
			{props.dispStyle === 'icon' ? 
				<IconButton color="inherit" onClick={()=>fileInput.current.click()}>
					<AddIcon/>
				</IconButton>
				:
				<Button 
					variant={props.variant ? props.variant : 'contained'}
					color="primary" 
					disabled={props.disabled}
					onClick={()=>fileInput.current.click()}>
					{t(props.caption)}
				</Button>
			}

			<input 
				id='img-input'
				ref={fileInput} 
				style={{display: 'none'}} 
				type='file' 
				accept={acceptMask()}
				onChange={handleImageChange}
			/>

			<ProgDialog 
				caption={t('common.upload')} 
				isOpen={progDlgOpen} 
				prog={prog} 
				msg={msg}
				handleClose={handleClose}
				errmsg={errmsg}
			/>
		</Fragment>
	);
}

export default UploadButton;
